export function isInspections(item) {
  const groupId = Number(item?.service_group?.id);
  const groupName = (item?.service_group?.name || "").toLowerCase();
  return groupId === 1 || groupName.includes("inspection");
}

export function isCollections(item) {
  const groupId = Number(item?.service_group?.id);
  const groupName = (item?.service_group?.name || "").toLowerCase();
  return groupId === 2 || groupName.includes("collection");
}

/** INTEGER=2, DECIMAL=3 — otherwise free text (string, date, oil quality, etc.). */
export function isNumericCollectionType(item) {
  const typeId = Number(item?.service_type?.id);
  return typeId === 2 || typeId === 3;
}

export function isDecimalCollectionType(item) {
  return Number(item?.service_type?.id) === 3;
}

/** Service unit id 1 / name "none" means no unit label should be shown. */
export function hasCollectionUnitLabel(item) {
  const unitId = Number(item?.service_unit?.id);
  const unitName = (item?.service_unit?.name || "").trim().toLowerCase();
  if (!unitName || unitId === 1 || unitName === "none") {
    return false;
  }
  return true;
}

export function getCollectionUnitLabel(item) {
  if (!hasCollectionUnitLabel(item)) return null;
  return item.service_unit.name;
}

export function normalizeCollectionValue(item, rawValue) {
  const value = rawValue ?? "";
  if (!isNumericCollectionType(item)) {
    return value;
  }
  if (isDecimalCollectionType(item)) {
    const cleaned = value.replace(/[^\d.]/g, "");
    const parts = cleaned.split(".");
    if (parts.length <= 1) return cleaned;
    return `${parts[0]}.${parts.slice(1).join("")}`;
  }
  return value.replace(/\D/g, "").slice(0, 10);
}

export function collectionValueFromPart(savedPart) {
  if (!savedPart) return "";
  if (savedPart.quantity != null && savedPart.quantity !== "") {
    return String(savedPart.quantity);
  }
  return savedPart.description || "";
}

export function buildCollectionPartProps(item, state) {
  const raw = state?.unit != null ? String(state.unit).trim() : "";
  if (!raw) return [];

  if (isNumericCollectionType(item)) {
    const num = Number(raw);
    if (Number.isFinite(num)) {
      return [{ key: "quantity", number: num }];
    }
  }

  return [{ key: "description", string: raw }];
}
